import { RECEIVE_PRODUCTS_ERROR } from '../productListConstants';

const formatFiltersForURL = itemsPerFacet => {
  const paramsArray = Object.entries(itemsPerFacet).flatMap(([facetId, itemValues]) => {
    const cleanFacetId = facetId.replace('@', '').toLowerCase();

    if (cleanFacetId === 'price') {
      return itemValues.map(value => {
        const numbers = value.match(/\d+/g);

        if (numbers && numbers.length === 2) {
          const rangeValue = `${numbers[0]}~${numbers[1]}`;
          return `&${encodeURIComponent(cleanFacetId)}=${encodeURIComponent(rangeValue)}`;
        }

        if (numbers && numbers.length === 1 && value.includes('+')) {
          const rangeValue = `${numbers[0]}~`;
          return `&${encodeURIComponent(cleanFacetId)}=${encodeURIComponent(rangeValue)}`;
        }

        return '';
      });
    }
    return itemValues.map(value => `&${encodeURIComponent(cleanFacetId)}=${encodeURIComponent(value).toLowerCase()}`);
  });

  return paramsArray.join('');
};

const formatSortForURL = selectedSort => {
  switch (selectedSort) {
    case 'price-asc':
      return '&sort=price~asc';
    case 'price-desc':
      return '&sort=price~desc';
    case 'newness':
      return '&sort=published~desc';
    case 'bestSellerRanking-asc':
      return '&sort=average_purchases~desc';
    case 'averageCustomerReview':
      return '&sort=reviewsaveragescore~desc';
    case 'relevance':
    default:
      return '';
  }
};

const formatPaginationForURL = (page, pageSize) => {
  return `&pg=${page}&ps=${pageSize}`;
};

export async function performAdvancedSearch(
  query,
  currency,
  customer,
  appliedFilters = {},
  selectedSort = '',
  page = 1,
  pageSize = 24,
  categoryId = '$',
  dispatch = () => {}
) {
  if (typeof window.$g === 'undefined') {
    console.error('GrapheneHC ($g) is not available.');
    return Promise.reject(new Error('GrapheneHC library not loaded.'));
  }

  const { locale, userIp, warehouseUk, warehouseUs } = window.inlineGlobalConfig || {};

  const languageId = locale.isoCode.toLowerCase().replace('_', '-');

  const template = categoryId && categoryId !== '$' ? 'category' : 'search';

  const filterString = formatFiltersForURL(appliedFilters);
  const sortString = formatSortForURL(selectedSort);
  const paginationString = formatPaginationForURL(page, pageSize);

  const customerFacingUrl = new URL(window.location.origin);

  let customerPath = `/${locale.country}/${locale.language}/`;
  if (template === 'category') {
    customerPath += `shop/${categoryId}`;
  } else {
    customerPath += 'search';
  }
  customerFacingUrl.pathname = customerPath.replace(/\/+/g, '/');

  const params = [];
  if (template === 'search' && query) {
    params.push(`q=${encodeURIComponent(query)}`);
  }

  if (locale.country) {
    params.push(`site-searchability=${locale.country.toLowerCase()}`);
  }

  if (filterString) params.push(filterString.substring(1));
  if (sortString) params.push(sortString.substring(1));
  if (paginationString) params.push(paginationString.substring(1));

  if (params.length > 0) {
    customerFacingUrl.search = `?${params.filter(p => p).join('&')}`;
  }

  const finalPageUrl = customerFacingUrl.href;

  const warehouseId = locale.country === 'us' || locale.country === 'ca' ? warehouseUs : warehouseUk;

  const requestPayload = {
    user: {
      uid: customer?.id || null,
      sid: null,
      ip_address: userIp || null,
    },
    template,
    page_context: {
      language_id: languageId,
      currency_id: currency,
      category_id: categoryId,
      page_url: finalPageUrl,
      warehouse_id: [warehouseId],
    },
    response_options: {
      fields: {
        products: ['id', 'stock', 'url', 'titles', 'media', 'pricing', 'features', 'skus', 'properties', 'published'],
        product_features: [],
      },
    },
  };

  try {
    return await window.$g.json(requestPayload);
  } catch (error) {
    dispatch({
      type: RECEIVE_PRODUCTS_ERROR,
    });

    console.error('GrapheneHC search request failed:', error);
    throw error;
  }
}
